/**
 * api接口的统一出口
*/
import Login from '@/api/Login';
import setup from '@/api/setup';
import goods from '@/api/goods';
import order from '@/api/order';
import info from '@/api/info';
import home from '@/api/home';
import mantiopl from '@/api/mantiopl'
import village from '@/api/village'
import article from '@/api/article'
import contentManagement from '@/api/contentManagement'
import robot from '@/api/robot'
//族谱
import Genealogy from '@/api/Genealogy'
import approval from '@/api/approval'
import travel from '@/api/travel';
import integral from '@/api/integral';
import serviceArticle from '@/api/serviceArticle';

export default {
    Login,
    setup,
    order,
    info,
    village,
    mantiopl,
    home,
    article,
    goods, contentManagement, Genealogy,
    approval, travel,
    integral,
    serviceArticle,
    robot

}



// WEBPACK FOOTER //
// ./src/api/index.js